import { useDataContext } from 'context/data-context'
import { Facebook } from './facebook'
import { Instagram } from './instagram'
import { Telegram } from './telegram'
import { Twitter } from './twitter'
import { YouTube } from './youtube'
import { SocialContainer } from './styled'
import { TikTok } from './tiktok'

export const Social = () => {
  const { strings } = useDataContext()

  return (
    <SocialContainer>
      {!!strings.link_facebook && (
        <a href={strings.link_facebook} target="_blank" rel="noreferrer">
          <Facebook />
        </a>
      )}
      {!!strings.link_twitter && (
        <a href={strings.link_twitter} target="_blank" rel="noreferrer">
          <Twitter />
        </a>
      )}
      {!!strings.link_youtube && (
        <a href={strings.link_youtube} target="_blank" rel="noreferrer">
          <YouTube />
        </a>
      )}
      {!!strings.link_instagram && (
        <a href={strings.link_instagram} target="_blank" rel="noreferrer">
          <Instagram />
        </a>
      )}
      {!!strings.link_tiktok && (
        <a href={strings.link_tiktok} target="_blank" rel="noreferrer">
          <TikTok />
        </a>
      )}
      {!!strings.link_telegram && (
        <a href={strings.link_telegram} target="_blank" rel="noreferrer">
          <Telegram />
        </a>
      )}
    </SocialContainer>
  )
}
